import { Field } from '@base-ui/react';
import { FC } from 'react';

import HelperDescription from '../Helper/HelperDescription';
import Label from '../Label';
import { StyledBox, StyledResizeHandle, StyledRoot, StyledTextarea } from './TextArea.styled';
import type { TextAreaProps } from './types';

const ResizeHandleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 2L2 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TextArea: FC<TextAreaProps> = ({
  label,
  optional,
  required,
  tooltip,
  topRightLabel,
  helperText,
  state = 'default',
  iconStart,
  containerClassName,
  disabled,
  changed,
  ...rest
}) => (
  <StyledRoot
    disabled={disabled}
    invalid={state === 'destructive'}
    className={containerClassName}
    data-changed={changed ? 'true' : undefined}
  >
    {label && (
      <Field.Label
        render={
          <Label
            optional={optional}
            required={required}
            tooltip={tooltip}
            topRightLabel={topRightLabel}
          >
            {label}
          </Label>
        }
      />
    )}
    <StyledBox $state={state}>
      <Field.Control
        disabled={disabled}
        render={<StyledTextarea required={required} {...rest} />}
      />
      <StyledResizeHandle>
        <ResizeHandleIcon />
      </StyledResizeHandle>
    </StyledBox>
    <HelperDescription state={state} iconStart={iconStart} label={helperText} />
  </StyledRoot>
);

TextArea.displayName = 'TextArea';

export default TextArea;
